window.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('.aps-search').length) {
    let $search = document.querySelector('.aps-search')
    let $searchClose = $search.querySelector('.aps-search__icon--close')
    let $searchInput = $search.querySelector('.aps-search__input')
    let $searchSubmit = $search.querySelector('.aps-search__submit')

    function toggleSearch() {
      let isActive = $search.classList.contains('aps-search--active')
      if (isActive) {
        $search.classList.remove('aps-search--active')
        setTimeout(function () {
          $search.style.visibility = 'hidden'
        }, 700)
      } else {
        $search.style.visibility = 'visible'
        $search.classList.add('aps-search--active')
        setTimeout(function () {
          $searchInput.focus()
        }, 100)
      }
    }

    $searchClose.addEventListener('click', function (ev) {
      ev.preventDefault()
      toggleSearch()
      window.aps.toggleHeaderSearch()
    })

    $searchSubmit.addEventListener('click', function () {
      $searchInput.setAttribute('readonly', true)
      $searchSubmit.setAttribute('disabled', true)
      $searchSubmit.classList.add('aps-search__submit--loading')
    })

    window.aps.toggleSearch = toggleSearch
  }
})
